import React from "react";
import { useRouteMatch } from "react-router-dom";

// `key` remonta o wrapper a cada rota nova e reinicia o fade de entrada da página.
export function Content({ children }) {
  const match = useRouteMatch() || {};

  return (
    <div key={match.url} className="jds-fade">
      {children}
    </div>
  );
}
